import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
const pageLinks = [APP_ROUTES.KICKSTARTER_CALCULATOR, APP_ROUTES.PRIMOPRINT, APP_ROUTES.INDUSTRIOUS, APP_ROUTES.AMERICANUNDERGROUND, APP_ROUTES.WEWORK, APP_ROUTES.SPRING, APP_ROUTES.TECHSTARS, APP_ROUTES.OFFICE, APP_ROUTES.STARBUCKS, APP_ROUTES.SEARCH_RESULTS];
export default function (pathname) {
  if (pageLinks.indexOf(pathname) >= 0) {
    return `${window.location.protocol}//${window.location.host}/`;
  }
  return window.location.href.split('?')[0];
}